import { AddressTypes, ECategoryOfWarehouse } from '@models';
import { AddressSettings } from '@shared';

export function checkPackingServiceDisabled(AddressSender, AddressRecipient, toggleFn: () => void): boolean {
  if (!AddressSender?.value || !AddressRecipient?.value) {
    return false;
  }

  const senderAddress = AddressSender.getRawValue ? AddressSender.getRawValue() : AddressSender.value;
  const recipientAddress = AddressRecipient.getRawValue ? AddressRecipient.getRawValue() : AddressRecipient.value;

  let disabled: boolean;

  const isSenderPostomat = senderAddress.data?.CategoryOfWarehouse === ECategoryOfWarehouse.Postomat;

  switch (senderAddress.type) {
    case AddressTypes.WAREHOUSE:
      disabled = isSenderPostomat
        ? isDisabledForPostboxSender(senderAddress)
        : isDisabledForWarehouseSender(senderAddress, recipientAddress);
      break;
    case AddressTypes.POSTBOX:
      disabled = isDisabledForPostboxSender(senderAddress);
      break;
    default:
      disabled = true;
  }

  if (disabled) {
    toggleFn();
  }

  return disabled;
}

function isDisabledForWarehouseSender(senderAddress, recipientAddress): boolean {
  const noSendingWarehouseSelected = !senderAddress.data?.warehouse && !senderAddress.data?.Ref;
  if (noSendingWarehouseSelected) {
    return true;
  }

  const receivedByDoors = recipientAddress.type === AddressTypes.DOORS;
  const receivedByPostbox = recipientAddress.type === AddressTypes.POSTBOX;
  const receivedByIndexAddressPostbox = recipientAddress.type === AddressTypes.INDEX
    && recipientAddress.data?.warehouse?.TypeOfWarehouse === AddressSettings.POSTBOX_TYPE;
  const noReceivingWarehouseSelected = !recipientAddress.data?.warehouse
    && !recipientAddress.data?.Ref
    && !recipientAddress.data?.postbox;

  const recipientCategoryOfWarehouseAllowedTypes = [
    ECategoryOfWarehouse.Branch,
    ECategoryOfWarehouse.Store,
    ECategoryOfWarehouse.DropOff,
  ];
  const receivedByBranch = recipientCategoryOfWarehouseAllowedTypes.some(
    type => type === recipientAddress.data?.warehouse?.CategoryOfWarehouse
      || type === recipientAddress.data?.CategoryOfWarehouse
      || type === recipientAddress.data?.postbox?.CategoryOfWarehouse,
  );

  return receivedByDoors
    || receivedByPostbox
    || receivedByIndexAddressPostbox
    || noReceivingWarehouseSelected
    || !receivedByBranch;
}

function isDisabledForPostboxSender(senderAddress): boolean {
  const noSendingPostboxSelected = !senderAddress.data?.postbox && !senderAddress.data?.Ref;
  return noSendingPostboxSelected;
}
